module.exports = __webpack_public_path__ + "static/media/9mobile.81b972cb.svg";